<template>
  <div class="list_wrapper">
    <b-table
      hover
      :fields="fields"
      :bordered="bordered"
      :items="items"
      show-empty
    >
      <template #empty>
        <h6>등록된 문항이 없습니다.</h6>
      </template>

      <template #cell(문제순서)="data">
        {{ data.item.qserial }}
      </template>

      <template #cell(pay)="data">
        <b-checkbox
          @change="chgpayfor(data.item)"
          v-model="data.item.is_forpay_tf"
          name="check-button"
          switch
        >
        </b-checkbox>
      </template>

      <template #cell(문제코드)="data">
        <a href="#" @click.prevent="view(data.item)">
          {{ data.item.qcode }}
        </a>
        <b-button
          class="float-right"
          size="sm"
          variant="danger"
          @click="removeQ(data.item)"
          >D</b-button
        >
        <b-button
          class="float-right"
          style="margin-right: 10px"
          size="sm"
          variant="success"
          @click="preview(data.item)"
          >미리보기</b-button
        >
      </template>
      <template #custom-foot>
        <td colspan="3">
          <b-button @click="addQ" class="float-right">문제등록</b-button>
        </td>
      </template>
    </b-table>
    <div style="pagelayout">
      <b-pagination
        v-model="currentPage"
        :total-rows="count"
        per-page="10"
        limit="10"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bordered: true,
      orig_meta_id:0,
    };
  },
  computed: {
    currentPage: {
      get() {
        return this.$store.state.currentPage;
      },
      set(val) {
        this.$store.commit("updateCurrentPage", val);
      },
    },
    count() {
      return this.$store.state.count;
    },
    fields() {
      return this.$store.state.questionlist_field;
    },
    items() {
      return this.$store.state.questionlist;
    },
  },
  watch: {
    currentPage(to, from) {
      // console.log("....");
      let book_id = this.$store.state.book_id;
      this.$store.dispatch("loadQuestionList", book_id);
    },
  },
  methods: {
    addQ() {
      // this.$store.commit("resetQuestionMeta");
      // this.$store.commit("resetQuestionForm");
      // this.$store.state.questionform.q_type = "1";
      // this.$store.state.qforms = [];
      // this.$store.dispatch("getNextSerial");
      // this.$store.state.mode = "form";

      this.$store.dispatch("ResetForReady");
    },
    removeQ(item) {
      if (confirm("삭제하시겠습니까?")) {
        this.$store.dispatch("removeQuestionFullByMeta", item.id);
      }
    },
    preview(item) {
      this.$store.commit("resetQuestionMeta");
      this.$store.commit("resetQuestionForm");

      this.$store.state.mode = "preview";
      this.$store.dispatch("loadQuestionFullByMeta", item.id);
    },
    view(item) {
      if(item.id !== this.orig_meta_id){
      this.$store.commit("resetQuestionMeta");
      this.$store.commit("resetQuestionForm");
      this.$store.state.mode = "form";
      //타입 체크 및  문제 로드
      // this.$store.commit("updateGrpType", "2");
      this.$store.dispatch("loadQuestionFullByMeta", item.id);
          }
      this.orig_meta_id = item.id;
    },
    chgpayfor(item) {
      this.$nextTick(() => {
        if (item.is_forpay_tf) {
          item.is_forpay = 1;
        } else {
          item.is_forpay = 0;
        }
        this.$store.dispatch("updatepaymode", item);
      });
    },
  },
};
</script>


<style lang="scss">
.list_wrapper {
  margin-top: 20px;
}
.qf_cls1 {
  max-width: 10px;
}
.pagelayout {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
